export default __webpack_public_path__ + "static/media/nodebits.c8997ea8.svg";